import { FC, useContext, useRef, useEffect } from 'react'
import YouTube from 'react-youtube'

import statisticContext from 'context/statisticsContext'

import { videoOpts, statisticEvent } from '../data'
import { IYouTubeVideo } from '../youtube.type'

import iframeStyle from '../iframe.module.scss'

const TICK = 10000

const YoutubeVideo: FC<IYouTubeVideo> = ({
  videoId,
  materialId,
  materialType,
  noAnalytics,
  refPlayer,
}: IYouTubeVideo) => {
  const socket = useContext(statisticContext)
  const interval = useRef<any>(null)

  const sendData = (eventName: string) => {
    if (!socket) return

    socket?.sendEvent(eventName, {
      id: materialId,
      materialType: materialType,
      timestamp: Date.now(),
    })
  }

  const handleStateChange = (e: any) => {
    const event = e.data
    const playerEvent = statisticEvent[event]
    if (!playerEvent) return
    if (noAnalytics) return

    if (playerEvent === 'playVideo' && materialId && materialType) {
      sendData('playVideoRecord')
      interval.current = setInterval(() => sendData('playVideoRecord'), TICK)
    }

    if (playerEvent === 'pauseVideo' || (playerEvent === 'endVideo' && interval?.current)) {
      sendData('pauseVideoRecord')
      clearInterval(interval.current)
    }
  }

  useEffect(() => {
    return () => {
      if (interval?.current) {
        sendData('pauseVideoRecord')
        clearInterval(interval.current)
      }
    }
  }, [])

  const checkVkLink = (link: string | undefined) => {
    if (!link) return false
    return link.includes('vk.com')
  }

  if (checkVkLink(videoId)) {
    return (
      <iframe
        src={videoId}
        width="100%"
        height="100%"
        allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
        className={iframeStyle.vkIfrarme}
      ></iframe>
    )
  }

  return (
    <YouTube
      videoId={videoId}
      opts={videoOpts}
      onStateChange={handleStateChange}
      className={iframeStyle.innerVideo}
      ref={refPlayer}
      id="youtubeIframe"
    />
  )
}

export default YoutubeVideo
